// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1TOsf","col":"CardReaderDesc_col__3SH4k","label":"CardReaderDesc_label__3PutE"};